// extracted by mini-css-extract-plugin
module.exports = {"body":"OptionsModal_body__1ug6O","control":"OptionsModal_control__S800B","controlLabel":"OptionsModal_controlLabel__268Dd"};